(() => {
  if (window.Shopify?.designMode) return;

  const startProtection = () => {
    const protectedRoot = document.querySelector('#MainContent');
    if (!protectedRoot || protectedRoot.dataset.lcProtectionReady === 'true') return;
    protectedRoot.dataset.lcProtectionReady = 'true';
    document.documentElement.classList.add('lc-content-protected');

    const isEditable = (target) =>
      target instanceof Element && Boolean(target.closest('input, textarea, select, option, [contenteditable="true"]'));
    const isProtectedTarget = (target) => target instanceof Element && protectedRoot.contains(target);

    protectedRoot.querySelectorAll('img, video').forEach((media) => {
      media.setAttribute('draggable', 'false');
      media.setAttribute('data-lc-protected-media', '');
    });

    document.addEventListener(
      'contextmenu',
      (event) => {
        if (isProtectedTarget(event.target) && !isEditable(event.target)) event.preventDefault();
      },
      { capture: true }
    );

    document.addEventListener(
      'dragstart',
      (event) => {
        if (isProtectedTarget(event.target) && event.target instanceof Element && event.target.closest('img, video')) {
          event.preventDefault();
        }
      },
      { capture: true }
    );

    document.addEventListener(
      'copy',
      (event) => {
        const selection = window.getSelection();
        const anchor = selection?.anchorNode instanceof Element ? selection.anchorNode : selection?.anchorNode?.parentElement;
        if (anchor && protectedRoot.contains(anchor) && !isEditable(event.target)) event.preventDefault();
      },
      { capture: true }
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (isEditable(event.target)) return;
        const key = event.key.toLowerCase();
        const blockedShortcut =
          event.key === 'F12' ||
          ((event.ctrlKey || event.metaKey) && (key === 'u' || key === 's')) ||
          ((event.ctrlKey || event.metaKey) && event.shiftKey && (key === 'i' || key === 'j' || key === 'c'));
        if (blockedShortcut) event.preventDefault();
      },
      { capture: true }
    );
  };

  if ('requestIdleCallback' in window) window.requestIdleCallback(startProtection, { timeout: 1800 });
  else window.setTimeout(startProtection, 900);
})();
